import React, { useEffect, useState } from "react";
import { SectionTitle } from "./_components/SectionTitle";
import { CustomAccordion } from "./_components/CustomAccordion";
import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "src/components/ui/breadcrumb";
import { Link } from "react-router-dom";
import SurveyTaker from "../Admin/Surveys/_components/SurveyTaker";
import axios from "axios";
import { BaseUrlApi, ErrorMessage } from "../../lib/api";
import { toast } from "sonner";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { CalendarDays, ListChecks } from "lucide-react";
import { Button } from "../../components/ui/button";
import MainButton from "../../components/MainButton";
import { DateFormate } from "../../lib/utils";
import { motion } from "framer-motion";
import CardSkeleton from "../../components/common/CardSkeleton";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTrigger,
} from "../../components/ui/drawer";
import QuizTaker from "../User/Quiz/_components/quiz-taker";
import { useLanguage } from "../../context/LanguageContext";

export default function MainSurvay() {
  const [isSurvayStart, setIsSurvayStart] = useState(false);
  const [oneSurvay, setOneSurvay] = useState({});

  const [surveys, setSurveys] = useState([]);
  const [loadingSurveys, setLoadingSurveys] = useState(true);
  const getAllSurveys = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/surveys`);
      setSurveys(data.data);
    } catch (error) {
      toast("Error", { description: ErrorMessage(error) });
    } finally {
      setLoadingSurveys(false);
    }
  };

  useEffect(() => {
    getAllSurveys();
  }, []);

  return (
    <div className="space-y-20 max-w-7xl mx-auto px-4 mt-14">
      <div className="space-y-6">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">الصفحة الرئيسية</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbSeparator />

            <BreadcrumbItem>
              <BreadcrumbPage className="font-semibold">
                الاستبيانات
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <div className="space-y-4 text-center">
          <SectionTitle title={"استبيان تقييم الطلاب للمنصة التعليمية"} />
          <p className="text-lg text-muted-foreground">
            نشكرك على تخصيص وقتك لتقييم تجربتك مع المنصة التعليمية. يساعدنا رأيك
            في تحسين خدماتنا وتقديم تجربة تعليمية أفضل.
          </p>
        </div>
      </div>

      {loadingSurveys ? (
        <CardSkeleton />
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {surveys.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <SurveyCard
                item={item}
                title={item.title}
                description={item.description}
                createdAt={item.created_at}
                questionCount={item.questions.length}
              />
            </motion.div>
          ))}
        </div>
      )}

      {/* <div className="">
        {!loadingSurveys && <SurveyTaker questions={surveys[0]?.questions} />}
      </div> */}
    </div>
  );
}

function SurveyCard({ title, description, createdAt, questionCount, item }) {
  return (
    <Card className="max-w-md mx-auto hover:shadow-lg transition-shadow duration-200">
      <CardHeader>
        <CardTitle className="text-lg md:text-xl truncate flex-1">
          {title}
        </CardTitle>
        <CardDescription className="inline-flex items-center gap-1 text-sm font-medium text-muted-foreground">
          <ListChecks className="w-4 h-4" />
          {questionCount} سؤال
        </CardDescription>
      </CardHeader>

      <CardContent className="pb-4">
        <div
          className="text-sm font-medium"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </CardContent>

      <CardFooter className="flex items-center justify-between pt-0">
        <div className="flex items-center text-sm text-muted-foreground gap-1">
          <CalendarDays className="w-4 h-4" />
          {DateFormate(createdAt)}
        </div>
        <DrawerOpenSurvay item={item} />
      </CardFooter>
    </Card>
  );
}

const DrawerOpenSurvay = ({ item }) => {
  const { language } = useLanguage();

  return (
    <Drawer>
      <DrawerTrigger asChild>
        <MainButton title={"ابدأ الاستبيان"} />
      </DrawerTrigger>
      <DrawerContent dir={language === "ar" ? "rtl" : "ltr"}>
        <div className="h-[calc(100vh-2rem)] max-w-7xl w-full mx-auto overflow-auto hide-scrollbar">
          <DrawerHeader className="flex items-center justify-between flex-wrap gap-4">
            <div className="w-full sm:w-fit">
              <p className="font-bold text-2xl pt-5" id="category">
                Survay Questions “{item?.title || "---"}”
              </p>
              {/* <p className="font-medium text-sm">
                {t.reviewTestForStudent} Review{" "}
              </p> */}
            </div>
            <div className="flex items-center gap-2 w-full sm:w-fit">
              <DrawerClose asChild>
                <Button
                  variant="outline"
                  className="w-full sm:w-fit h-10 rounded-xl border-2 border-blue-600 text-blue-600 hover:text-blue-500"
                >
                  Close
                </Button>
              </DrawerClose>
            </div>
          </DrawerHeader>
          <div className="p-4">
            <SurveyTaker questions={item.questions} survey={item} />
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
